/**
 * Public shop origin — where the in-app "shop" retargets (driver-store DC card,
 * ICP CTAs) point. Delivered via VITE_SHOP_ORIGIN (sst.config.ts), which is
 * https://evinitiative.shop on every stage — the raw Shop CloudFront URL must
 * never leak into user-facing links. Falls back to the same domain when unset
 * (local dev), so links always resolve.
 */
const RAW = import.meta.env['VITE_SHOP_ORIGIN'];
export const SHOP_ORIGIN = (RAW && String(RAW).trim())
  ? String(RAW).trim().replace(/\/+$/, '')
  : 'https://evinitiative.shop';

/** Build an absolute shop URL from a path (e.g. shopUrl('/commercial-dc')). */
export function shopUrl(path = ''): string {
  if (!path) return SHOP_ORIGIN;
  return `${SHOP_ORIGIN}${path.startsWith('/') ? path : `/${path}`}`;
}
